import React from 'react';
import Banner from '../components/Banner';
import HeroSection from '../components/HeroSection';
import ExcellenceSection from '../components/ExcellenceSection';
import AdmissionPage from '../components/AdmissionPage';
import GroupsSection from '../components/GroupsSection';

function HomePage() {
  return (
    <>
      <Banner/>
      <HeroSection />
      <ExcellenceSection />
      <AdmissionPage />
      <GroupsSection />
    </>
  );
}

export default HomePage;